<template>
  <div class="week-menu-listing">
        <masonry :cols="{default: 3, 1200: 2, 800: 1}" :gutter="30">
        <div v-for="(day, index) in week" :key="index">
            <div class="menu-box z-depth-2" :class="{ 'today z-depth-5' : parseInt(day.week_menu_day.value) === today }" data-aos="zoom-in">
              <h2 class="day">{{ day.week_menu_day.label }}</h2>
              <div v-for="(item, index) in day.week_menu_content" :key="index" class="menu-content-item">
                <p class="text"> {{ item.week_menu_entree }}</p>
                <p class="divider">***</p>
                <p class="text"> {{ item.week_menu_plat }}</p>
                <p class="divider">***</p>
                <p class="text">{{ item.week_menu_dessert }}</p>
                <p class="divider">***</p>
                <p class="price">CHF {{ item.week_menu_price }}</p>
              </div>
            </div>
        </div>
        </masonry>
      </div>
</template>
<script>
import api from '@/api'
export default {
  data () {
    return {
      week: null,
      today: 0,
      currentDay: 0
    }
  },
  methods: {
    /**
     * Fetch week menu data
     * @request HTTP | GET
     */
    fetchMenu () {
      let url = api.week_menu_page
      this.axios(url).then(response => {
        this.week = response.data[0].acf.week_menu
      }).catch(error => {
        console.log(error)
      })
    }
  },
  beforeMount () {},
  mounted () {
    this.fetchMenu()
  },
  created () {
    // Set today date
    let today = new Date()
    this.today = today.getDay()
  }
}
</script>
<style lang="sass" scoped>
  @import 'WeekMenuListing'
</style>



// WEBPACK FOOTER //
// src/components/WeekMenu/WeekMenuListing.vue